var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOthersFunction03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 638.999,
    height: 644,
    viewBox: "0 0 638.999 644",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "\\uC0AC\\uAC01\\uD615_1081",
    x: 0,
    y: 149,
    width: 208,
    height: 208,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2768ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "\\uC0AC\\uAC01\\uD615_1084",
    x: 213,
    y: 0,
    width: 209,
    height: 209,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2768ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "\\uC0AC\\uAC01\\uD615_1085",
    x: 346,
    y: 39,
    width: 207,
    height: 208,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2768ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "\\uC0AC\\uAC01\\uD615_1086",
    x: 212.999,
    y: 435,
    width: 209,
    height: 209,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2768ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "\\uC0AC\\uAC01\\uD615_1087",
    x: 80.999,
    y: 39,
    width: 208,
    height: 209,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2768ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "\\uC0AC\\uAC01\\uD615_1088",
    x: 431.999,
    y: 149,
    width: 207,
    height: 207,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2768ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "\\uC0AC\\uAC01\\uD615_1089",
    x: 0,
    y: 288,
    width: 208,
    height: 208,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2768ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "\\uC0AC\\uAC01\\uD615_1090",
    x: 426,
    y: 288,
    width: 206,
    height: 206,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2768ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "\\uC0AC\\uAC01\\uD615_1091",
    x: 86,
    y: 397,
    width: 208,
    height: 208,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2768ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "\\uC0AC\\uAC01\\uD615_1092",
    x: 341,
    y: 397,
    width: 208,
    height: 208,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2768ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2860",
    "data-name": "\\uADF8\\uB8F9 2860",
    transform: "translate(-1021 -4077)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1093",
    "data-name": "\\uC0AC\\uAC01\\uD615 1093",
    width: 434,
    height: 434,
    rx: 217,
    transform: "translate(1115 4169)",
    fill: "#e9efff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2815",
    "data-name": "\\uADF8\\uB8F9 2815",
    transform: "translate(1069.343 4267.88)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -48.34, -190.88)",
    filter: "url(#\\uC0AC\\uAC01\\uD615_1081)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1081-2",
    "data-name": "\\uC0AC\\uAC01\\uD615 1081",
    width: 100,
    height: 100,
    rx: 50,
    transform: "translate(48 191)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2807",
    "data-name": "\\uADF8\\uB8F9 2807",
    transform: "translate(24.657 32.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5037",
    "data-name": "\\uD328\\uC2A4 5037",
    d: "M81.864,95.656a.963.963,0,0,1,.921-.877l3.622-.146V93.451c0-2.36.929-3.22,3.008-3.22h5.328a2.513,2.513,0,0,1,1.084.2v5.881a.734.734,0,0,1-.733.733H94.1c-.32,0-.786-.1-1.134-.972l-1.182-3.02a.645.645,0,1,0-1.2.47l1.184,3.023A2.466,2.466,0,0,0,94.1,98.333H95.1a2.025,2.025,0,0,0,2.023-2.023V92.035l2.4,3.611a1.772,1.772,0,0,1,.132.181c1.259,1.788,4.669,1.917,5.853,1.889H121.17c7.226-1.1,8.215-5.851,8.264-6.109a1.654,1.654,0,0,1,3.263.539,9.743,9.743,0,0,1-2.522,4.721,13.5,13.5,0,0,1-7,3.827l.022,13.432a1.975,1.975,0,0,1,2.975,1.706v8.419a1.978,1.978,0,0,1-3.956,0v-5.289c-.032.013-.06.032-.092.043a1.64,1.64,0,0,1-1.815-.476l-4.359-5.848a.646.646,0,0,0-.609-.266l-13.266,1.6v10.234a1.978,1.978,0,1,1-3.956,0v-9.744l-3.007.373v9.37a1.978,1.978,0,0,1-3.956,0s.027-17.95.026-17.96l-.344-2.831c-.659-1.443-2.147-2.175-4.428-2.175a4.22,4.22,0,0,1-3.264-1.32,6.22,6.22,0,0,1-1.28-4.311Z",
    transform: "translate(-81.849 -90.231)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5038",
    "data-name": "\\uD328\\uC2A4 5038",
    d: "M381.412,338.14l4.427,6.244v4.264a1.978,1.978,0,0,1-3.956,0v-5.412a1.628,1.628,0,0,1-2.1-.275l-3.732-4.13Z",
    transform: "translate(-348.142 -314.626)",
    fill: "#2d50b8"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1021, 4077)",
    filter: "url(#\\uC0AC\\uAC01\\uD615_1084)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1084-2",
    "data-name": "\\uC0AC\\uAC01\\uD615 1084",
    width: 101,
    height: 101,
    rx: 50.5,
    transform: "translate(261 42)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5039",
    "data-name": "\\uD328\\uC2A4 5039",
    d: "M207.916,68.182c.122-5.268-4.288-7.718-6.86-6.615-2.419,1.037-7.872,1.532-8.513,1.587-.642-.055-6.093-.55-8.513-1.587-2.573-1.1-6.983,1.347-6.86,6.615s3.307,12.741,3.307,14.945-.735,17.027,4.165,18.13c4.884,1.1,1.372-16.3,7.9-16.413,6.528.112,3.016,17.512,7.9,16.413s4.165-15.926,4.165-18.13,3.185-9.678,3.306-14.945Z",
    transform: "translate(1139.834 4088.692)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2823",
    "data-name": "\\uADF8\\uB8F9 2823",
    transform: "translate(1415.199 4158.444)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -394.2, -81.44)",
    filter: "url(#\\uC0AC\\uAC01\\uD615_1085)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1085-2",
    "data-name": "\\uC0AC\\uAC01\\uD615 1085",
    width: 99,
    height: 100,
    rx: 49.5,
    transform: "translate(394 81)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "noun-doctor-3266429",
    d: "M116.46-.015A1.4,1.4,0,0,0,115.2,1.378v9.849a10.074,10.074,0,0,0,10.064,10.064h.65V35.062a6.822,6.822,0,0,1-6.864,6.875H114.6a6.824,6.824,0,0,1-6.866-6.875V30.271a6.944,6.944,0,1,0-2.8,0v4.788a9.676,9.676,0,0,0,9.663,9.671h4.449a9.673,9.673,0,0,0,9.66-9.671V21.291h.661a10.074,10.074,0,0,0,10.064-10.064V1.378a1.4,1.4,0,0,0-1.393-1.393h-3.469a1.4,1.4,0,1,0,0,2.8h2.065v8.445a7.222,7.222,0,0,1-7.268,7.268h-4.108A7.222,7.222,0,0,1,118,11.226V2.782h2.065a1.4,1.4,0,1,0,0-2.8h-3.468q-.067,0-.134,0ZM106.332,19.309a4.154,4.154,0,0,1,.041,8.308c-.029,0-.058,0-.087,0a4.153,4.153,0,0,1,.046-8.305Z",
    transform: "translate(-69.54 28.132)",
    fill: "#2d50b8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2818",
    "data-name": "\\uADF8\\uB8F9 2818",
    transform: "translate(1282.019 4553.856)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -261.02, -476.86)",
    filter: "url(#\\uC0AC\\uAC01\\uD615_1086)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1086-2",
    "data-name": "\\uC0AC\\uAC01\\uD615 1086",
    width: 101,
    height: 101,
    rx: 50.5,
    transform: "translate(261 477)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2808",
    "data-name": "\\uADF8\\uB8F9 2808",
    transform: "translate(26.134 27.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5040",
    "data-name": "\\uD328\\uC2A4 5040",
    d: "M167.224,226.46l2.372,2.372-20.548,22.125c-.768.768-2.753.213-3.438-.473s-1.241-3-.473-3.765Z",
    transform: "translate(-144.071 -208.461)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5041",
    "data-name": "\\uD328\\uC2A4 5041",
    d: "M143.021,245.236a3.485,3.485,0,0,1-3.785-3.274,2.974,2.974,0,0,1,.5-2.52l22.6-20.728,3.315,3.314-21,22.616a2.222,2.222,0,0,1-1.628.593Zm19.275-24.6-21.6,19.808a1.858,1.858,0,0,0-.093,1.286,3.176,3.176,0,0,0,.588,1.476,3.045,3.045,0,0,0,1.828.641.936.936,0,0,0,.628-.168l20.074-21.615Z",
    transform: "translate(-139.164 -201.675)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5042",
    "data-name": "\\uD328\\uC2A4 5042",
    d: "M303.163,140.054,292.45,129.341l9-9,10.713,10.713Z",
    transform: "translate(-273.449 -115.494)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5043",
    "data-name": "\\uD328\\uC2A4 5043",
    d: "M296.227,134.1l-11.695-11.695,9.983-9.983,11.695,11.695Zm-9.732-11.695,9.731,9.731,8.02-8.02-9.731-9.731Z",
    transform: "translate(-266.513 -108.559)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5044",
    "data-name": "\\uD328\\uC2A4 5044",
    d: "M261.28,98.171l9-9,2.436,2.436-9,9Z",
    transform: "translate(-246.143 -88.188)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5045",
    "data-name": "\\uD328\\uC2A4 5045",
    d: "M256.777,94.652l-3.417-3.417,9.983-9.983,3.417,3.417Zm-1.454-3.417,1.454,1.454,8.02-8.02-1.454-1.454Z",
    transform: "translate(-239.205 -81.251)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5046",
    "data-name": "\\uD328\\uC2A4 5046",
    d: "M390.38,229.531l9-9,2.251,2.252-9,9Z",
    transform: "translate(-359.241 -203.265)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5047",
    "data-name": "\\uD328\\uC2A4 5047",
    d: "M385.691,225.825l-3.233-3.233,9.984-9.983,3.233,3.233Zm-1.27-3.233,1.27,1.27,8.02-8.02-1.27-1.27Z",
    transform: "translate(-352.301 -196.327)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5048",
    "data-name": "\\uD328\\uC2A4 5048",
    d: "M394.687,442.01H371.97v-1.357a2.721,2.721,0,0,1,2.721-2.721h17.276a2.721,2.721,0,0,1,2.721,2.721Z",
    transform: "translate(-343.113 -393.72)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5049",
    "data-name": "\\uD328\\uC2A4 5049",
    d: "M390.484,437.795h-24.1v-2.052a3.419,3.419,0,0,1,3.415-3.415h17.276a3.419,3.419,0,0,1,3.415,3.415Zm-22.717-1.388H389.1v-.663a2.028,2.028,0,0,0-2.026-2.026H369.794a2.028,2.028,0,0,0-2.026,2.026Z",
    transform: "translate(-338.216 -388.81)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5050",
    "data-name": "\\uD328\\uC2A4 5050",
    d: "M396.47,410.63h16.643v3.384H396.47Z",
    transform: "translate(-364.576 -369.802)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5051",
    "data-name": "\\uD328\\uC2A4 5051",
    d: "M408.91,409.8H390.88V405.03h18.03Zm-16.643-1.389h15.255v-2H392.267Z",
    transform: "translate(-359.679 -364.896)",
    fill: "#2d50b8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2822",
    "data-name": "\\uADF8\\uB8F9 2822",
    transform: "translate(1149.869 4158.444)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -128.87, -81.44)",
    filter: "url(#\\uC0AC\\uAC01\\uD615_1087)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1087-2",
    "data-name": "\\uC0AC\\uAC01\\uD615 1087",
    width: 100,
    height: 101,
    rx: 50,
    transform: "translate(129 81)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2809",
    "data-name": "\\uADF8\\uB8F9 2809",
    transform: "translate(28.491 28.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5052",
    "data-name": "\\uD328\\uC2A4 5052",
    d: "M179.868,159.662a1.471,1.471,0,0,0-1.88-.887s-8.272,2.959-17,6.086a2.85,2.85,0,0,0-.737-.9l-5.944-4.307,2.845-8.192c1.164-3.278-.324-5.14-.324-5.14s-.259-.444-.652-1.126l-7.087,1.815.324-1.189,18.43-4.722a1.13,1.13,0,0,0-.562-2.189L154.461,142.2c-.31-.549-.617-1.1-.9-1.614-1.077-1.953-3.523-3.409-6.462-1.057-1.266,1.014-1.625,2.9-1.727,4.622-.008.123-.015.255-.024.383l-5.684,1.457-.4-.155a1.7,1.7,0,1,0-1.227,3.161l7.557,2.934a1.7,1.7,0,0,0,2.232-1.071l.026-.085,1.452,2.553c.339.6.291,5.98.291,5.98.076,1.619.154,2.422,1.165,3.275l5.9,3.83c-6.8,2.433-13.081,4.688-15.094,5.419a4.2,4.2,0,0,1-3.953-.442c.565,3.179,2.755,3.956,4.076,3.526l37.3-13.374a1.47,1.47,0,0,0,.886-1.878Zm-34.736-11.55-1.851-.719,1.924-.493c-.042.706-.073,1.212-.073,1.212Z",
    transform: "translate(-136.955 -130.197)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5053",
    "data-name": "\\uD328\\uC2A4 5053",
    d: "M175.28,62.2a4.313,4.313,0,1,1-4.313-4.313A4.313,4.313,0,0,1,175.28,62.2",
    transform: "translate(-163.657 -57.892)",
    fill: "#2d50b8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2819",
    "data-name": "\\uADF8\\uB8F9 2819",
    transform: "translate(1500.889 4267.88)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -479.89, -190.88)",
    filter: "url(#\\uC0AC\\uAC01\\uD615_1088)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1088-2",
    "data-name": "\\uC0AC\\uAC01\\uD615 1088",
    width: 99,
    height: 99,
    rx: 49.5,
    transform: "translate(480 191)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2810",
    "data-name": "\\uADF8\\uB8F9 2810",
    transform: "translate(27.408 27.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5054",
    "data-name": "\\uD328\\uC2A4 5054",
    d: "M169.687,301.629a1.908,1.908,0,0,0,1.348.559h27.278a2.384,2.384,0,0,1,2.384,2.384v0a2.384,2.384,0,0,1-2.383,2.383H169.851a3.814,3.814,0,0,1-2.7-1.118l-8.641-8.641a2.384,2.384,0,1,1,3.371-3.372l7.8,7.8Z",
    transform: "translate(-156.826 -269.76)",
    fill: "#2d50b8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5055",
    "data-name": "\\uD328\\uC2A4 5055",
    d: "M343.157,235.918V219.7a.954.954,0,1,0-1.907,0v16.214a.954.954,0,1,0,1.907,0Z",
    transform: "translate(-320.267 -203.489)",
    fill: "#2d50b8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5056",
    "data-name": "\\uD328\\uC2A4 5056",
    d: "M343.157,418.88V412.2a.954.954,0,0,0-1.907,0v6.676a.954.954,0,1,0,1.907,0Z",
    transform: "translate(-320.267 -375.007)",
    fill: "#2d50b8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5057",
    "data-name": "\\uD328\\uC2A4 5057",
    d: "M205.635,78.892A15.258,15.258,0,0,0,192.492,94v.954h9.545c.115-6.824,1.455-12.677,3.321-15.652.091-.144.183-.282.277-.414Zm8.049,0c.094.132.186.27.277.414,1.865,2.975,3.207,8.828,3.322,15.652h9.545v-.954a15.258,15.258,0,0,0-13.144-15.112Zm1.69,16.066H203.946c.092-5.453.976-10.251,2.321-13.285a7.879,7.879,0,0,1,1.427-2.293,1.721,1.721,0,0,1,1.18-.636h1.572a1.72,1.72,0,0,1,1.179.636,7.864,7.864,0,0,1,1.428,2.293c1.346,3.034,2.229,7.832,2.321,13.285Z",
    transform: "translate(-187.724 -78.744)",
    fill: "#2d50b8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5058",
    "data-name": "\\uD328\\uC2A4 5058",
    d: "M150.38,419.561l6.4-6.4H184.6l6.4,6.4a.953.953,0,0,0,1.348-1.348l-6.676-6.676a.951.951,0,0,0-.674-.279H156.381a.951.951,0,0,0-.674.279l-6.676,6.676a.953.953,0,0,0,1.348,1.348Z",
    transform: "translate(-148.751 -375.013)",
    fill: "#2d50b8",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1021, 4077)",
    filter: "url(#\\uC0AC\\uAC01\\uD615_1089)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1089-2",
    "data-name": "\\uC0AC\\uAC01\\uD615 1089",
    width: 100,
    height: 100,
    rx: 50,
    transform: "translate(48 330)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2811",
    "data-name": "\\uADF8\\uB8F9 2811",
    transform: "translate(1092 4439)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5059",
    "data-name": "\\uD328\\uC2A4 5059",
    d: "M242.92,306.429l-.436-.186-12.065-5.151a1.746,1.746,0,0,0-2.623,1.733V308.4c0,4.5,6.967,8.151,15.56,8.151s15.562-3.649,15.562-8.151v-5.573a1.746,1.746,0,0,0-2.623-1.733l-12.066,5.151-.436.186a1.277,1.277,0,0,1-.873,0Z",
    transform: "translate(-216.426 -280.55)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5060",
    "data-name": "\\uD328\\uC2A4 5060",
    d: "M162.814,141.687,139.592,151.6c-1.449.618-1.449,1.621,0,2.24l23.221,9.913a7.651,7.651,0,0,0,5.246,0L181,158.229l10.283-4.39c1.448-.618,1.448-1.621,0-2.24l-23.221-9.912A7.641,7.641,0,0,0,162.814,141.687Z",
    transform: "translate(-138.506 -141.223)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5061",
    "data-name": "\\uD328\\uC2A4 5061",
    d: "M540.5,226.8h2.223v16.64H540.5Z",
    transform: "translate(-489.311 -215.903)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5062",
    "data-name": "\\uD328\\uC2A4 5062",
    d: "M540.016,345.16c0,.618-.705,1.12-1.575,1.12s-1.574-.5-1.574-1.12v-2.724c0-.619.7-1.12,1.574-1.12s1.575.5,1.575,1.12Z",
    transform: "translate(-486.14 -315.836)",
    fill: "#2d50b8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2820",
    "data-name": "\\uADF8\\uB8F9 2820",
    transform: "translate(1494.694 4407.255)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -473.69, -330.25)",
    filter: "url(#\\uC0AC\\uAC01\\uD615_1090)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1090-2",
    "data-name": "\\uC0AC\\uAC01\\uD615 1090",
    width: 98,
    height: 98,
    rx: 49,
    transform: "translate(474 330)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2812",
    "data-name": "\\uADF8\\uB8F9 2812",
    transform: "translate(29.902 16.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5063",
    "data-name": "\\uD328\\uC2A4 5063",
    d: "M220.627,272.614H199.161a6.564,6.564,0,1,1,0-13.115h7.44a3.575,3.575,0,1,0,0-1.788h-7.44a8.352,8.352,0,1,0,0,16.7h21.466a6.564,6.564,0,0,1,0,13.115H200.61a3.575,3.575,0,1,0,0,1.788h20.017a8.352,8.352,0,0,0,0-16.7Z",
    transform: "translate(-190.569 -224.173)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5064",
    "data-name": "\\uD328\\uC2A4 5064",
    d: "M284.958,26.915a.891.891,0,0,0,1.56,0l7.013-12.665a9.475,9.475,0,0,0,.083-8.973,8.669,8.669,0,0,0-6.9-4.721,10.166,10.166,0,0,0-2,0,8.669,8.669,0,0,0-6.9,4.721,9.475,9.475,0,0,0,.082,8.973Zm.8-19.126a1.884,1.884,0,1,1-1.333.552A1.886,1.886,0,0,1,285.759,7.789Z",
    transform: "translate(-266.274 -0.506)",
    fill: "#2d50b8"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1021, 4077)",
    filter: "url(#\\uC0AC\\uAC01\\uD615_1091)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1091-2",
    "data-name": "\\uC0AC\\uAC01\\uD615 1091",
    width: 100,
    height: 100,
    rx: 50,
    transform: "translate(134 439)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5065",
    "data-name": "\\uD328\\uC2A4 5065",
    d: "M113.12,167.61l3.213,13.436H167.45l7.3-13.436h-9.2l-2.483-6.28h-4.454l-1.753-6.061H136.049v-4.454h-2.556l-1.241-5.769H130.5v5.769h-3.14l-1.022,4.454h-1.46l-1.388,6.061h-2.921l-1.9,6.28Zm54.549,1.972h3.87v.657h-3.87Zm-32.5-16.138h-6.5v-1.1h6.5Zm-4.6,13H126.7v-2.921h3.87Zm3.943-9.274v2.921h-3.87v-2.921Zm1.388,9.274h-3.87v-2.921h3.87Zm3.943-6.28h-3.87V157.24h3.87Zm1.315,6.28h-3.87v-2.921h3.87Zm4.016-6.28h-3.87V157.24h3.87Zm6.645,6.28h-3.87v-2.921h3.87Zm4.016-6.28h-3.87V157.24h3.87Zm1.241,6.28h-3.87v-2.921h3.87Zm2.775,4.819a1.327,1.327,0,0,1,1.388-1.314,1.373,1.373,0,0,1,1.388,1.314,1.327,1.327,0,0,1-1.388,1.314A1.372,1.372,0,0,1,159.856,171.26Zm-1.314-7.813h3.87v2.921h-3.87Zm-2.848,7.813a1.327,1.327,0,0,1,1.388-1.314,1.373,1.373,0,0,1,1.388,1.314,1.39,1.39,0,0,1-2.775,0Zm-4.163,0a1.327,1.327,0,0,1,1.388-1.314,1.373,1.373,0,0,1,1.388,1.314,1.39,1.39,0,0,1-2.775,0Zm-4.235,0a1.327,1.327,0,0,1,1.388-1.314,1.314,1.314,0,0,1,0,2.628A1.326,1.326,0,0,1,147.3,171.26Zm-.657-14.094h3.87v2.921h-3.87Zm-4.016,6.28h3.87v2.921h-3.87ZM138.9,171.26a1.327,1.327,0,0,1,1.388-1.314,1.373,1.373,0,0,1,1.388,1.314,1.327,1.327,0,0,1-1.388,1.314A1.372,1.372,0,0,1,138.9,171.26Zm-4.163,0a1.327,1.327,0,0,1,1.388-1.314,1.373,1.373,0,0,1,1.388,1.314,1.39,1.39,0,0,1-2.775,0Zm-4.162,0a1.327,1.327,0,0,1,1.388-1.314,1.373,1.373,0,0,1,1.388,1.314,1.39,1.39,0,0,1-2.775,0Zm-4.235,0a1.327,1.327,0,0,1,1.388-1.314,1.373,1.373,0,0,1,1.388,1.314,1.327,1.327,0,0,1-1.388,1.314A1.372,1.372,0,0,1,126.338,171.26Zm-1.022-14.094h3.87v2.921h-3.87Zm-3.14,14.094a1.327,1.327,0,0,1,1.388-1.314,1.314,1.314,0,1,1,0,2.628A1.326,1.326,0,0,1,122.175,171.26Zm-.876-7.813h3.87v2.921H121.3Zm-3.286,7.813a1.327,1.327,0,0,1,1.388-1.314,1.373,1.373,0,0,1,1.388,1.314,1.39,1.39,0,0,1-2.775,0Z",
    transform: "translate(1060.879 4402.954)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2816",
    "data-name": "\\uADF8\\uB8F9 2816",
    transform: "translate(1410.037 4515.658)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -389.04, -438.66)",
    filter: "url(#\\uC0AC\\uAC01\\uD615_1092)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1092-2",
    "data-name": "\\uC0AC\\uAC01\\uD615 1092",
    width: 100,
    height: 100,
    rx: 50,
    transform: "translate(389 439)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2813",
    "data-name": "\\uADF8\\uB8F9 2813",
    transform: "translate(20.461 25.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5066",
    "data-name": "\\uD328\\uC2A4 5066",
    d: "M376.987,78.349a4.22,4.22,0,1,1-5.968,0,4.22,4.22,0,0,1,5.968,0",
    transform: "translate(-337.65 -77.113)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5067",
    "data-name": "\\uD328\\uC2A4 5067",
    d: "M270.494,150.608l-.466.466a3.227,3.227,0,0,1-4.57,0l-9.687-9.687c-.128.176-7.5,7.565-7.5,7.565l6.665,6.659h0a2.923,2.923,0,0,1,.865,2.076v14.176H253.35a3.127,3.127,0,0,1-3.13-3.13v-9.937l-7.9-7.9h0a3.384,3.384,0,0,1-.757-.575l-1.082-1.082h0a3.779,3.779,0,0,1,0-5.341l8.444-8.437a4.534,4.534,0,0,1,5.726-.568,4.028,4.028,0,0,1,.7.568l5.969,5.962Z",
    transform: "translate(-222.983 -127.245)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5068",
    "data-name": "\\uD328\\uC2A4 5068",
    d: "M55.908,309.242a11.154,11.154,0,1,1-11.154-11.154,11.154,11.154,0,0,1,11.154,11.154",
    transform: "translate(-33.6 -271.413)",
    fill: "none",
    stroke: "#2d50b8",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5069",
    "data-name": "\\uD328\\uC2A4 5069",
    d: "M363.908,309.242a11.154,11.154,0,1,1-11.154-11.154,11.154,11.154,0,0,1,11.154,11.154",
    transform: "translate(-304.419 -271.413)",
    fill: "none",
    stroke: "#2d50b8",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2825",
    "data-name": "\\uADF8\\uB8F9 2825",
    transform: "translate(-4.08 380)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2761",
    "data-name": "\\uADF8\\uB8F9 2761",
    transform: "translate(1265.079 4047.558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2760",
    "data-name": "\\uADF8\\uB8F9 2760",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2",
    "data-name": "\\uD328\\uC2A4 2",
    d: "M162.418,41.86h11.1v2.65H169.3V55.982h-2.727V44.51h-4.155Z",
    transform: "translate(-162.418 -41.86)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3",
    "data-name": "\\uD328\\uC2A4 3",
    d: "M199.635,50.843h2.621V61.288h-2.621v-1.1a5.167,5.167,0,0,1-1.539,1.052,4.335,4.335,0,0,1-1.674.321,4.646,4.646,0,0,1-3.5-1.569,5.472,5.472,0,0,1-1.477-3.9,5.614,5.614,0,0,1,1.429-3.965,4.552,4.552,0,0,1,3.471-1.545,4.414,4.414,0,0,1,1.764.356,4.8,4.8,0,0,1,1.525,1.065Zm-2.754,2.151a2.648,2.648,0,0,0-2.019.858,3.428,3.428,0,0,0,.014,4.43,2.649,2.649,0,0,0,2.013.875,2.7,2.7,0,0,0,2.048-.86,3.146,3.146,0,0,0,.813-2.251,3.051,3.051,0,0,0-.813-2.207A2.732,2.732,0,0,0,196.881,52.994Z",
    transform: "translate(-180.094 -47.166)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4",
    "data-name": "\\uD328\\uC2A4 4",
    d: "M228.459,45.168V48.7a4.908,4.908,0,0,1,1.536-1.065,4.436,4.436,0,0,1,1.767-.356,4.564,4.564,0,0,1,3.477,1.545,5.615,5.615,0,0,1,1.429,3.965,5.477,5.477,0,0,1-1.478,3.9,4.657,4.657,0,0,1-3.5,1.569A4.379,4.379,0,0,1,230,57.944a5.153,5.153,0,0,1-1.545-1.052V58h-2.6V45.168Zm2.755,4.534a2.731,2.731,0,0,0-2.054.845,3.042,3.042,0,0,0-.816,2.207,3.136,3.136,0,0,0,.816,2.251,2.711,2.711,0,0,0,2.054.86,2.663,2.663,0,0,0,2.02-.875,3.421,3.421,0,0,0,.014-4.43A2.674,2.674,0,0,0,231.214,49.7Z",
    transform: "translate(-201.046 -43.874)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5",
    "data-name": "\\uD328\\uC2A4 5",
    d: "M258.309,45.168h2.621V58h-2.621Z",
    transform: "translate(-220.806 -43.874)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_6",
    "data-name": "\\uD328\\uC2A4 6",
    d: "M280.8,56.824h-8.419a2.8,2.8,0,0,0,.975,1.771,3.057,3.057,0,0,0,2.02.657,3.49,3.49,0,0,0,2.525-1.027l2.209,1.037a5.2,5.2,0,0,1-1.978,1.733,6.163,6.163,0,0,1-2.735.562,5.409,5.409,0,0,1-4-1.551,5.278,5.278,0,0,1-1.544-3.884,5.458,5.458,0,0,1,1.539-3.969,5.182,5.182,0,0,1,3.865-1.579,5.373,5.373,0,0,1,4.013,1.579,5.714,5.714,0,0,1,1.545,4.172Zm-2.621-2.065a2.627,2.627,0,0,0-1.025-1.42,2.964,2.964,0,0,0-1.774-.548,3.137,3.137,0,0,0-1.923.615,3.43,3.43,0,0,0-.962,1.353Z",
    transform: "translate(-227.832 -47.166)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7",
    "data-name": "\\uD328\\uC2A4 7",
    d: "M304.775,41.86h2.618l3.274,9.85,3.3-9.85h2.616l2.371,14.122h-2.6l-1.515-8.919-3,8.919h-2.368L306.5,47.063l-1.551,8.919H302.33Z",
    transform: "translate(-247.611 -41.86)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8",
    "data-name": "\\uD328\\uC2A4 8",
    d: "M356.544,50.843h2.621V61.288h-2.621v-1.1a5.177,5.177,0,0,1-1.539,1.052,4.338,4.338,0,0,1-1.674.321,4.644,4.644,0,0,1-3.5-1.569,5.47,5.47,0,0,1-1.478-3.9,5.614,5.614,0,0,1,1.429-3.965,4.553,4.553,0,0,1,3.471-1.545,4.417,4.417,0,0,1,1.764.356,4.8,4.8,0,0,1,1.525,1.065Zm-2.755,2.151a2.65,2.65,0,0,0-2.02.858,3.43,3.43,0,0,0,.014,4.43,2.65,2.65,0,0,0,2.013.875,2.7,2.7,0,0,0,2.049-.86,3.148,3.148,0,0,0,.812-2.251,3.053,3.053,0,0,0-.812-2.207A2.734,2.734,0,0,0,353.789,52.994Z",
    transform: "translate(-275.635 -47.166)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_9",
    "data-name": "\\uD328\\uC2A4 9",
    d: "M382.766,50.843h2.622v1.071A6.275,6.275,0,0,1,387,50.867a3.907,3.907,0,0,1,1.481-.293,3.591,3.591,0,0,1,2.637,1.086,3.727,3.727,0,0,1,.91,2.725v6.9h-2.592V56.713a11.588,11.588,0,0,0-.167-2.483,1.7,1.7,0,0,0-.585-.934,1.635,1.635,0,0,0-1.029-.322,1.927,1.927,0,0,0-1.365.533,2.841,2.841,0,0,0-.79,1.472,11.867,11.867,0,0,0-.115,2.118v4.191h-2.622Z",
    transform: "translate(-296.588 -47.166)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10",
    "data-name": "\\uD328\\uC2A4 10",
    d: "M419.9,50.843h2.622V61.288H419.9v-1.1a5.147,5.147,0,0,1-1.538,1.052,4.332,4.332,0,0,1-1.674.321,4.648,4.648,0,0,1-3.5-1.569,5.475,5.475,0,0,1-1.476-3.9,5.616,5.616,0,0,1,1.428-3.965,4.552,4.552,0,0,1,3.47-1.545,4.418,4.418,0,0,1,1.765.356,4.794,4.794,0,0,1,1.525,1.065Zm-2.754,2.151a2.65,2.65,0,0,0-2.02.858,3.428,3.428,0,0,0,.015,4.43,2.648,2.648,0,0,0,2.013.875,2.7,2.7,0,0,0,2.049-.86,3.145,3.145,0,0,0,.813-2.251,3.051,3.051,0,0,0-.813-2.207A2.73,2.73,0,0,0,417.143,52.994Z",
    transform: "translate(-314.212 -47.166)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11",
    "data-name": "\\uD328\\uC2A4 11",
    d: "M453.122,50.843h2.612V59.79a5.913,5.913,0,0,1-1.066,3.9,5.337,5.337,0,0,1-4.311,1.69,7.549,7.549,0,0,1-2.58-.384,4.68,4.68,0,0,1-1.767-1.128,4.615,4.615,0,0,1-1.065-1.81h2.889a2.386,2.386,0,0,0,.989.668,4.1,4.1,0,0,0,1.431.226,3.773,3.773,0,0,0,1.7-.328,1.981,1.981,0,0,0,.908-.845,4.314,4.314,0,0,0,.263-1.786,4.31,4.31,0,0,1-1.449.994,4.61,4.61,0,0,1-1.719.3,4.724,4.724,0,0,1-3.552-1.517,5.886,5.886,0,0,1,.087-7.833,4.576,4.576,0,0,1,3.322-1.365,4.407,4.407,0,0,1,1.7.332,5.412,5.412,0,0,1,1.607,1.089ZM450.4,53.022a2.726,2.726,0,0,0-2.044.83,2.871,2.871,0,0,0-.808,2.088,2.916,2.916,0,0,0,.826,2.141,2.794,2.794,0,0,0,2.073.835,2.681,2.681,0,0,0,2.012-.817,2.943,2.943,0,0,0,.79-2.139,2.906,2.906,0,0,0-.8-2.121A2.742,2.742,0,0,0,450.4,53.022Z",
    transform: "translate(-334.448 -47.166)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12",
    "data-name": "\\uD328\\uC2A4 12",
    d: "M489.008,56.824h-8.419a2.8,2.8,0,0,0,.975,1.771,3.056,3.056,0,0,0,2.021.657,3.488,3.488,0,0,0,2.524-1.027l2.209,1.037a5.2,5.2,0,0,1-1.979,1.733,6.156,6.156,0,0,1-2.734.562,5.411,5.411,0,0,1-4.005-1.551,5.277,5.277,0,0,1-1.544-3.884,5.456,5.456,0,0,1,1.54-3.969,5.182,5.182,0,0,1,3.865-1.579,5.375,5.375,0,0,1,4.013,1.579,5.716,5.716,0,0,1,1.545,4.172Zm-2.621-2.065a2.625,2.625,0,0,0-1.025-1.42,2.964,2.964,0,0,0-1.774-.548,3.137,3.137,0,0,0-1.923.615,3.439,3.439,0,0,0-.962,1.353Z",
    transform: "translate(-354.61 -47.166)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_13",
    "data-name": "\\uD328\\uC2A4 13",
    d: "M509.916,50.843h2.247v1.315a2.8,2.8,0,0,1,.969-1.181,2.333,2.333,0,0,1,1.324-.4,2.948,2.948,0,0,1,1.474.481l-.737,2.037a1.3,1.3,0,0,0-1.02-.407,1.776,1.776,0,0,0-1.249.931,6.846,6.846,0,0,0-.418,2.938l.01.51v4.224h-2.6Z",
    transform: "translate(-374.01 -47.166)",
    fill: "#2d50b8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2824",
    "data-name": "\\uADF8\\uB8F9 2824",
    transform: "translate(1279.532 3946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1",
    "data-name": "\\uD328\\uC2A4 1",
    d: "M99.484,7.7,94.6,13.532,107.518,24.36H35.592L15.607,7.7l-4.887,5.834L30.7,30.271V68.7l7.613,6.348V32.109h76.114V83.452H35.69L15.607,66.71l-4.887,5.834L32.985,91.2h89.052V26.5Z",
    transform: "translate(-10.721 -7.698)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1",
    "data-name": "\\uC0AC\\uAC01\\uD615 1",
    width: 8.646,
    height: 5.472,
    transform: "translate(41.44 38.862)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2",
    "data-name": "\\uC0AC\\uAC01\\uD615 2",
    width: 8.647,
    height: 5.472,
    transform: "translate(61.309 38.862)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3",
    "data-name": "\\uC0AC\\uAC01\\uD615 3",
    width: 8.646,
    height: 5.472,
    transform: "translate(81.377 38.862)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_4",
    "data-name": "\\uC0AC\\uAC01\\uD615 4",
    width: 8.646,
    height: 5.473,
    transform: "translate(41.44 55.916)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_5",
    "data-name": "\\uC0AC\\uAC01\\uD615 5",
    width: 8.647,
    height: 5.473,
    transform: "translate(61.309 55.916)",
    fill: "#2d50b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_6",
    "data-name": "\\uC0AC\\uAC01\\uD615 6",
    width: 8.646,
    height: 5.473,
    transform: "translate(81.377 55.916)",
    fill: "#2d50b8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthersFunction03);
export default __webpack_public_path__ + "static/media/others-function-03.65f416258c5b1674829c40f20419c336.svg";
export { ForwardRef as ReactComponent };